import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-users-search-modal',
  templateUrl: './users-search-modal.component.html',
  styleUrls: ['./users-search-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UsersSearchModalComponent implements AfterViewInit {

  ngAfterViewInit(): void {

  }

}
